export default "__VITE_ASSET__C6z3bAHl__"